import { create } from "zustand";

interface SocketState {
  connected: boolean;
  setConnected: (status: boolean) => void;
  namespace: string | undefined;
  setNamespace: (namespace: string | undefined) => void;
  examFinished: boolean;
  setExamFinished: (status: boolean) => void;
}

export const useSocketStore = create<SocketState>((set) => ({
  connected: false,
  setConnected: (status) => set({ connected: status }),
  namespace: "",
  setNamespace: (namespace) => set({ namespace }),
  examFinished: false,
  setExamFinished: (status) => set({ examFinished: status }),
}));
